<script lang="ts" setup>
import { ref } from "vue";
import { useVaccinationConfigurations } from "@/composables/tasks/vaccination/useVaccinationConfigurations";

const { getVaccinationConfigurationsHistory } = useVaccinationConfigurations();

const showHistory = ref(false);
// Toggle history display
const toggleHistory = () => {
  showHistory.value = !showHistory.value;
};

// Format history item display value
const getValueDisplay = (value: any): string => {
  if (!value) return 'None';
  return value.label || value.name || JSON.stringify(value);
};

</script>

<template>
  <div v-if="getVaccinationConfigurationsHistory().length > 0"
    class="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-md">
    <div class="flex items-center justify-between">
      <div>
        <span class="text-blue-700 text-sm font-medium">{{ getVaccinationConfigurationsHistory().length }} change(s)
          recorded</span>
      </div>
      <button @click="toggleHistory" class="text-blue-600 text-sm underline">
        {{ showHistory ? 'Hide History' : 'View History' }}
      </button>
    </div>

    <!-- Change history details -->
    <div v-if="showHistory" class="mt-3 border-t border-blue-200 pt-3">
      <div v-for="change in getVaccinationConfigurationsHistory()" :key="change.id"
        class="mb-3 pb-3 border-b border-blue-100 last:border-b-0">
        <div class="font-medium">{{ change.fieldName }}</div>
        <div>
          Changed from
          <span class="font-medium">{{ getValueDisplay(change.oldValue) }}</span> to
          <span class="font-medium">{{ getValueDisplay(change.newValue) }}</span>
        </div>
        <div class="mt-1 text-sm text-gray-600">
          <span class="text-gray-700 font-medium">Justification:</span> {{ change.justification }}
        </div>
        <div class="mt-1 text-xs text-gray-500">
          {{ new Date(change.timestamp).toLocaleString() }} by {{ change.userName }}
        </div>
      </div>
    </div>
  </div>
</template>